<template>
  <el-dialog class="global-dialog" :append-to-body="true" :visible.sync="dialogVisible" title="选择品种规格" width="1200px">
    <GrainSpecifications :isBulkOil="isBulkOil" is-choose @select="onSelect"></GrainSpecifications>
    <!-- <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </template> -->
  </el-dialog>
</template>

<script>
import GrainSpecifications from '@/views/grainSpecifications/GrainSpecifications'
export default {
  name: 'SpecChoose',
  components: {
    GrainSpecifications
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // isBulkOil 是否散油： 0：否，1：是
    isBulkOil: {
      type: String,
      default: ''
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.dialogVisible = true
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', newVal)
      }
    }
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  created() {
  },
  computed: {},
  methods: {
    onSelect(row) {
      this.dialogVisible = false
      this.$emit('select', row)
    }
  }
}
</script>

<style scoped lang="scss"></style>
